import { FormHelperText } from '@mui/material';
import { useTranslate } from 'react-admin';
import type { ReactNode } from 'react';

type Props = {
  helperText?: string | false | ReactNode;
};

export const InputHelperUnderLabel = ({ helperText }: Props) => {

  const translate = useTranslate();

  if (!helperText) return null;

  return (
    <FormHelperText className="input-helper-under-label" component="p" sx={{
      mt: 0, mb: 1, ml: 0, mr: 0,
    }}>
      {typeof helperText === 'string' ? translate(helperText) : helperText}
    </FormHelperText>
  );

};
